import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import { MdClose } from "react-icons/md";
import { BsArrowDown } from "react-icons/bs";
import Spinner from "react-bootstrap/esm/Spinner";
import ButtonImagePermission from "../../../../components/UI/Button/ButtonImagePermission";
import TablePagination from "../../../../components/UI/Table/TablePagination";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import funcionalidades from "../../../../context/AuthContext.funcionalidades";
import EfisModal from "../../../../components/UI/EfisModal/EfisModal";
import HtmlToString from "../../../../components/Formatters/HtmlToString";

const CarregandoView = (
  <span>
    <Spinner animation="border" role="status" /> Carregando ...
  </span>
);

const removeCell = (row, setShowDesassociarConfirm) => (
  <ButtonImagePermission
    permission={funcionalidades.ordemservico.deletarAltExecutor}
    className="btn-lg text-danger pa-0 p-0"
    onClick={() =>
      setShowDesassociarConfirm({
        show: true,
        body: `Deseja remover o executor ${row.nomeFormal}?`,
        context: row.codigoExecutor,
        status: row.status,
      })
    }
    buttonImage={<MdClose />}
    tooltipImage="Remover Auditor"
  />
);

const columns = [
  {
    name: "Setor",
    selector: (row) => row.siglaOrgao,
    center: true,
    sortable: true,
  },
  {
    name: "Nome",
    selector: (row) => row.nomeFormal,
    width: "30%",
    sortable: true,
  },
  {
    name: "Matrícula",
    selector: (row) => row.matricula,
    center: true,
  },
  {
    name: "Qtd Ações",
    selector: (row) => row.quantidadeOs,
    width: "12%",
    center: true,
    sortable: true,
  },
  {
    name: "Tipos de Ação Fiscal",
    cell: (row) =>
      row.quantidadeTipoAf ? (
        <span>
          <HtmlToString html={row.quantidadeTipoAf} />
        </span>
      ) : (
        ""
      ),
    width: "33%",
    center: true,
  },
];

const ListaExecutoresAssociadosOs = ({ acaoFiscal, associadoOsExcluido, sqAlteracaoExecutorOs }) => {
  const [executoresAssociadosOS, setExecutoresAssociadosOS] = useState([]);
  const [codExecutorExcluido, setCodExecutorExcluido] = useState("");

  const {
    request: deleteItemRequest,
    isLoading: deleteItemIsLoading,
    data: deleteItemData,
    errors: deleteItemErrors,
  } = useApiClient();

  const [showDesassociarConfirm, setShowDesassociarConfirm] = useState({
    show: false,
    body: null,
    context: null,
    status: null,
  });

  const { request: requestAssociadosOS, data: dataAssociadosOS, isLoading: isLoadingAssociadosOS } = useApiClient();

  useEffect(() => {
    const parametro = { sqAcaoFiscal: acaoFiscal };
    requestAssociadosOS(apiRoutes.fiscalizacao.alteracaoexecutor.consultaExecutorAltExcOs, parametro);
  }, [requestAssociadosOS, acaoFiscal]);

  useEffect(() => {
    if (dataAssociadosOS) {
      setExecutoresAssociadosOS(dataAssociadosOS.result);
    }
  }, [dataAssociadosOS]);

  useEffect(() => {
    if (!deleteItemData && !deleteItemErrors) return;

    if (deleteItemData && codExecutorExcluido !== "") {
      toast.success("Exclusão de executor salva com sucesso.");
      associadoOsExcluido(codExecutorExcluido);
      sqAlteracaoExecutorOs(deleteItemData.result);
      setCodExecutorExcluido("");
    }

    if (deleteItemErrors) {
      toast.error(deleteItemErrors);
    }

    setShowDesassociarConfirm({ show: false });
  }, [
    deleteItemData,
    deleteItemErrors,
    setShowDesassociarConfirm,
    associadoOsExcluido,
    codExecutorExcluido,
    sqAlteracaoExecutorOs,
  ]);

  const columnsAssociadosOS = [
    ...columns,
    {
      name: "Ações",
      selector: "",
      width: "10%",
      center: true,
      cell: (row) => removeCell(row, setShowDesassociarConfirm),
    },
  ];

  return (
    <>
      <EfisModal
        show={showDesassociarConfirm.show}
        body={showDesassociarConfirm.body}
        loadingConfirmationAction={deleteItemIsLoading}
        closeHandler={() => setShowDesassociarConfirm({ show: false })}
        confirmationHandler={() => {
          setCodExecutorExcluido(showDesassociarConfirm.context);
          const params = {
            sequencialAcaoFiscal: acaoFiscal,
            codigoExecutor: showDesassociarConfirm.context,
          };
          deleteItemRequest(apiRoutes.fiscalizacao.ordemservico.excluirAltExec, params);
        }}
      />
      <div className="col-lg-12">
        <div className="card shadow mb-4">
          <div className="card-header pt-3 pb-0 flex-row w-100">
            <h6 className="m-0 font-weight-bold text-primary flex-grow-1 py-3">Executores associados à OS </h6>
          </div>

          <div className="card-body">
            <DataTable
              noHeader
              title="Executores associados à OS"
              keyField="id"
              columns={columnsAssociadosOS}
              data={executoresAssociadosOS}
              progressPending={isLoadingAssociadosOS}
              noDataComponent="Nenhum registro para exibir"
              progressComponent={CarregandoView}
              defaultSortFieldId={1}
              sortIcon={<BsArrowDown />}
              pagination
              sortable
              pointerOnHover
              paginationComponent={TablePagination}
            />
          </div>
        </div>
      </div>{" "}
    </>
  );
};

export default ListaExecutoresAssociadosOs;
